﻿(function () {
  var storageKey = 'maisonSirajAttribution';
  var params = new URLSearchParams(window.location.search);
  var keys = ['creator', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function read() {
    try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (error) { return {}; }
  }

  function write(data) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(data));
      document.cookie = storageKey + '=' + encodeURIComponent(JSON.stringify(data)) + '; path=/; max-age=2592000; SameSite=Lax';
    } catch (error) {}
  }

  var attribution = read();
  var changed = false;
  keys.forEach(function (key) {
    var value = params.get(key);
    if (value) {
      attribution[key] = key === 'creator' || key === 'utm_content' ? value.trim().toUpperCase() : value.trim();
      changed = true;
    }
  });
  if (changed) {
    attribution.first_seen = attribution.first_seen || new Date().toISOString();
    attribution.last_seen = new Date().toISOString();
    attribution.landing_page = attribution.landing_page || window.location.pathname;
    attribution.referrer = attribution.referrer || document.referrer || '';
    write(attribution);
  }

  function fillFields() {
    var current = read();
    document.querySelectorAll('[data-ms-creator-field]').forEach(function (field) { field.value = current.creator || current.utm_content || ''; });
    document.querySelectorAll('[data-ms-utm-source-field]').forEach(function (field) { field.value = current.utm_source || ''; });
    document.querySelectorAll('[data-ms-utm-medium-field]').forEach(function (field) { field.value = current.utm_medium || ''; });
    document.querySelectorAll('[data-ms-utm-campaign-field]').forEach(function (field) { field.value = current.utm_campaign || ''; });
    document.querySelectorAll('[data-ms-utm-content-field]').forEach(function (field) { field.value = current.utm_content || ''; });
    document.querySelectorAll('[data-ms-utm-term-field]').forEach(function (field) { field.value = current.utm_term || ''; });
    document.querySelectorAll('[data-ms-landing-page-field]').forEach(function (field) { field.value = current.landing_page || window.location.pathname; });
    document.querySelectorAll('[data-ms-referrer-field]').forEach(function (field) { field.value = current.referrer || document.referrer || ''; });
    document.querySelectorAll('[data-ms-first-seen-field]').forEach(function (field) { field.value = current.first_seen || ''; });
    document.querySelectorAll('[data-ms-last-seen-field]').forEach(function (field) { field.value = current.last_seen || ''; });
  }

  function syncCart() {
    var current = read();
    if (!current.creator && !current.utm_source) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        creator_code: current.creator || current.utm_content || '',
        utm_source: current.utm_source || '',
        utm_medium: current.utm_medium || '',
        utm_campaign: current.utm_campaign || '',
        utm_content: current.utm_content || '',
        utm_term: current.utm_term || '',
        landing_page: current.landing_page || window.location.pathname,
        referrer: current.referrer || document.referrer || '',
        attribution_first_seen: current.first_seen || '',
        attribution_last_seen: current.last_seen || ''
      }})
    }).catch(function () {});
  }

  function initCountdowns() {
    document.querySelectorAll('[data-ms-countdown]').forEach(function (root) {
      var launch = new Date(root.getAttribute('data-ms-countdown')).getTime();
      if (!launch) return;
      var days = root.querySelector('[data-days]');
      var hours = root.querySelector('[data-hours]');
      var minutes = root.querySelector('[data-minutes]');
      var seconds = root.querySelector('[data-seconds]');
      function tick() {
        var distance = Math.max(0, launch - Date.now());
        var dayValue = Math.floor(distance / 86400000);
        var hourValue = Math.floor((distance % 86400000) / 3600000);
        var minuteValue = Math.floor((distance % 3600000) / 60000);
        var secondValue = Math.floor((distance % 60000) / 1000);
        if (days) days.textContent = String(dayValue).padStart(2, '0');
        if (hours) hours.textContent = String(hourValue).padStart(2, '0');
        if (minutes) minutes.textContent = String(minuteValue).padStart(2, '0');
        if (seconds) seconds.textContent = String(secondValue).padStart(2, '0');
      }
      tick();
      window.setInterval(tick, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fillFields();
    syncCart();
    initCountdowns();
  });
})();
